import React from "react";

const PageHeaderAction = () => {
  return (
    <>
      <li className="dropdown">
        {/* <a href="#" data-bs-toggle="dropdown" aria-expanded="false">
            <svg className="svg-stroke" xmlns="http://www.w3.org/2000/svg" width="22" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>
                <path d="M9 12l6 0"></path>
                <path d="M12 9l0 6"></path>
            </svg>
        </a> */}
        {/* <ul className="dropdown-menu dropdown-menu-end p-2 p-xl-3 shadow rounded-4">
            <li><a className="dropdown-item rounded-pill" href="#">New folder</a></li>
            <li><a className="dropdown-item rounded-pill" href="#">File upload</a></li>
            <li><a className="dropdown-item rounded-pill" href="#">Google docs</a></li>
            <li><a className="dropdown-item rounded-pill" href="#">Google sheets</a></li>
            <li><hr className="dropdown-divider"/></li>
            <li><a className="dropdown-item rounded-pill" href="#">+ Invite</a></li>
            <li><a className="dropdown-item rounded-pill" href="#">Generate report</a></li>
            <li><a className="dropdown-item rounded-pill" href="#">New Reports</a></li>
        </ul> */}
      </li>
      <li className="dropdown ms-3">
        {/* <a href="#" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
            <svg className="svg-stroke" xmlns="http://www.w3.org/2000/svg" width="22" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v7l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227z"></path>
            </svg>
        </a> */}
      </li>
    </>
  );
};

export default PageHeaderAction;
